export function checkpwd(password) {
  let alertmsg = '';
  let e = /\s+/;
  if (e.test(password)) {
    alertmsg = '密碼中不允許有空格';
  }
  if (password.length < 6 || password.length > 30) {
    alertmsg = '密碼為8~16位數字、字母';
  }
  if (/^\d+$/.test(password)) {
    alertmsg = '密碼不允許全為數字';
  }
  if (/^[a-z]+$/i.test(password)) {
    alertmsg = '密碼不允許全為字母，請包含至少1個數字';
  }
  if (!/^[A-Za-z0-9]+$/.test(password)) {
    alertmsg = '密碼不能包含特殊字符,仅支持数字,字母';
  }

  return alertmsg;
}


export function isSameWord(b) {
  var d;
  if (b != null && b != "") {
    d = b.charCodeAt(0);
    d = "\\" + d.toString(8);
    var c = "[" + d + "]{" + (b.length) + "}";
    var a = new RegExp(c);
    return a.test(b)
  }
  return true
}



export function timestampToTime(timestamp,millisecond = false) {
  timestamp = millisecond ? timestamp : timestamp*1000;
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  let D = change(date.getDate()) + ' ';
  let h = change(date.getHours()) + ':';
  let m = change(date.getMinutes());
  // let m = change(date.getMinutes()) + ':';
  // let s = change(date.getSeconds());
  return Y + M + D + h + m;
}

export function change(t) {
  if (t < 10) {
    return "0" + t;
  } else {
    return t;
  }
}


export function todayDate() {

  var myDate = new Date();
  var year = myDate.getFullYear();
  var mon = myDate.getMonth() + 1;
  var date = myDate.getDate();
  if (date < 10) {
    date = '0' + date;
  }
  var today = year + '' + mon + '' + date;
  return today;
}

/*
 *缓存key
 *
 */
export function getCacheKey(url, params={}) {
  return Object.keys(params).length === 0 ?  `${url}` : `${url}__params=${JSON.stringify(params)}`;
}


//节流函数
export function throttle(fn, gapTime) {
  if (gapTime == null || gapTime == undefined) {
    gapTime = 1500
  }

  let _lastTime = null

  // 返回新的函数
  return function () {
    let _nowTime = + new Date()
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      fn.apply(this, arguments)   //将this和参数传给原函数
      _lastTime = _nowTime
    }
  }
}


export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

//随机id
export function generateUniqueID() { 
  const array = new Uint32Array(2); 
  crypto.getRandomValues(array); 
  const uniqueID = array.join("-"); 
  return uniqueID; 
}



// WEBPACK FOOTER //
// ./src/box/common.js